// extracted by mini-css-extract-plugin
export default {"title":"Clients_title__CCxZX","card":"Clients_card__mbS8o","arrow":"Clients_arrow__J8556","swiper":"Clients_swiper__Rv3WL","client":"Clients_client__btyNw"};